import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-verify-phone',
  templateUrl: './verify-phone.component.html',
  styleUrls: ['./verify-phone.component.css']
})
export class VerifyPhoneComponent implements OnInit {
  leadId: string;
  code: string = "";
  phone: string;
  showCall: boolean = false;
  loading: boolean = false;
  showSMS: boolean = false;
  error: boolean = false;
  errors: any = [];
  stepCount: number = 0;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.leadId = params['id'];
      this.phone = params['phone'];

      this.api.sendSMS(this.leadId).subscribe(
          success => {
            this.showSMS = true;
          },
          error => {
            this.stepCount++;
          });
    });
  }

  verify() {
    this.loading = true;
    var code = { code: this.code };
    this.api.verify(this.leadId, code).subscribe(
      success => {
        this.stepCount++;
        this.loading = false;
      },
      error => {
        this.error = true;
        this.loading = false;

      });
  }


  sendSMS() {
    var phone = { phone: this.phone }
    this.api.editPhone(this.leadId, phone)
      .subscribe(success => {
        this.api.sendSMS(this.leadId).subscribe(
          success => {
            this.showSMS = true;
          },
          error => {
            this.error = true;
          });
      });
  }

  sendCall() {
    var phone = { phone: this.phone }
    this.api.editPhone(this.leadId, phone)
      .subscribe(success => {
        this.api.sendCall(this.leadId)
          .subscribe(
            success => {
              this.showCall = true;
            },
            error => {
              this.error = true;
            });
      }, error => {
        this.error = true;
      });
  }

  eleads_validate_phone(phone) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,6}$/im;
    this.errors['phone'] = !re.test(String(phone).toLowerCase());
  }


}
